import { render, staticRenderFns } from "./ExcelUploader.vue?vue&type=template&id=4980271a&"
import script from "./ExcelUploader.vue?vue&type=script&lang=js&"
export * from "./ExcelUploader.vue?vue&type=script&lang=js&"
import style0 from "./ExcelUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports